import { Tag, TagProps } from "@chakra-ui/react";
import { blueStyles } from "./Status/styles";

export default function ImmediateTag({ ...rest }: TagProps) {
  return (
    <Tag
      borderRadius="md"
      boxShadow="none"
      {...blueStyles}
      {...rest}
    >
      After Kickoff
    </Tag>
  );
}
